"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledProgress = exports.ProgressBarContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const Tokens = __importStar(require("../../styles/tokens"));
/**
 * Styling the progress element from its container is the recommended styling approach for
 * progress bars. This is due to different browsers having varying default styles for progress bars.
 * A reference can be found via: https://css-tricks.com/html5-progress-element/#aa-styling-progress-bars
 */
exports.ProgressBarContainer = styled_components_1.default.div `
    width: 100%;
    text-align: center;

    progress[value] {
        appearance: none;
        ${({ size }) => size === "small"
    ? `height: ${Tokens.SIZES[0.5]}`
    : `height: ${Tokens.SIZES[1]}`};

        ::-webkit-progress-bar {
            background-color: ${Tokens.COLOURS.primary.blue[25]};
        }

        ::-webkit-progress-value {
            background-color: ${Tokens.COLOURS.primary.blue[100]};
            border-top-right-radius: 100px;
            border-bottom-right-radius: 100px;
            ${({ complete }) => complete &&
    `
                border-top-right-radius: 0px;
                border-bottom-right-radius: 0px;
              `}
        }
    }
`;
exports.StyledProgress = styled_components_1.default.progress `
    width: 100%;
`;
//# sourceMappingURL=ProgressBar.styles.js.map